export function init(store, p, x) {
//    console.log('init store=',store,'p=',p,'x=',x);
    return x;
}
